import React, { Component } from 'react';
import { HeaderSub2 } from '../../Common/HeaderSub2'
import { HeaderSub } from '../../Common/HeaderSub'
import { Footer } from '../../Common/Footer'

import { SimpleFileUpLoad } from '../../Common/SimpleFileUpLoad'
import { MyInfo } from './MyInfo';
import { MyPage } from './MyPage';
import { MypageSub } from './MypageSub';

import { StoreInfo } from './StoreInfo';
import { BusinessInfo } from '../../Account/MemberMgr/BusinessInfo';
import { MyInfoCheck } from './MyInfoCheck';
import { AccountNumber } from './AccountNumber';

import { StoreMsg } from '../Notice/StoreMsg';
import { StoreMsgDtl } from '../Notice/StoreMsgDtl';
import { StoreMsgReg } from '../Notice/StoreMsgReg';
import { EmpList } from '../Eemployee/EmpList';
import { CostSettleList } from '../CostSettle/CostSettleList';

import { ServiceCenter } from '../Etc/ServiceCenter';
import { Withdrawal } from '../Etc/Withdrawal';

import { Privacypolicy } from '../../Account/MemberMgr/Privacypolicy';
import { Termsofservice } from '../../Account/MemberMgr/Termsofservice';

import { OrderDtlExcel } from '../../Order/OrderMgr/OrderDtlExcel';


import { Big3Common } from '../../../js/IncludeManager'


/* 개발담당:양유빈
 * 화면기능: 마이페이지 메인 
 * 세부설명:
*/

export class Index extends Component {
    static displayName = Index.name;

    constructor(props) {
        super(props);
        this.state = {
            RenderName: this.CompName.MyPage,  //기본 컴포넌트 할당
            ContentState: null
        };
    }
    CompName = {
        "MyPage": "MyPage",
        "MyInfo": "MyInfo",
        "StoreInfo": "StoreInfo",
        "AccountNumber":"AccountNumber",
        "BusinessInfo": "BusinessInfo",
        "StoreMsg": "StoreMsg",
        "StoreMsgDtl": "StoreMsgDtl",
        "StoreMsgReg": "StoreMsgReg",
        "EmpList": "EmpList",
        "CostSettleList": "CostSettleList",
        "ServiceCenter": "ServiceCenter",
        "Withdrawal": "Withdrawal",
        "MyInfoCheck": "MyInfoCheck",
        "PhotoUpload": "PhotoUpload",
        "Privacypolicy": "Privacypolicy",
        "Termsofservice": "Termsofservice",
        "OrderDtlExcel":"OrderDtlExcel"
    }
    //초기화
    componentDidMount() {
    }
    componentWillUnmount() {
        Big3Common.HistoryBackToClearBackdoor();
    }
    renderPick() {

        if (this.state.RenderName === this.CompName.MyPage) {
            const IsSecondary = Big3Common.WebStorage.GetLocalStorage(Big3Common.WebStorage.StorageName.IsSecondary);
            return (
                <div>
                    <HeaderSub2
                        HeaderTitle="마이페이지"
                        HistoryBack={true}
                        RenderComponent={(RenderName) => this.setState({ RenderName: RenderName })}
                        ComponentName={this.state.RenderName}

                    />
                    {
                        IsSecondary === 'Y' ? <MypageSub RenderComponent={(RenderName) => this.setState({ RenderName: RenderName })} /> : 
                        <MyPage RenderComponent={(RenderName) => this.setState({ RenderName: RenderName })} />
                    }
                    <Footer
                        ComponentName={this.state.RenderName}
                        fillName="icon5"
                    />
                </div>

            )
            
        }
        else if (this.state.RenderName === this.CompName.MyInfo) {
            
            return (
                <div>
                    <HeaderSub
                        HeaderTitle="내정보"
                        ComponentUrl="MyPage"
                        RenderComponent={(RenderName) => this.setState({ RenderName: RenderName })}
                        ComponentName={this.state.RenderName}
                    />
                    <MyInfo
                        RenderComponent={(RenderName) => this.setState({ RenderName: RenderName})}
                        ContentState={this.state.ContentState}
                    />
                </div>
            );
        }
        else if (this.state.RenderName === this.CompName.MyInfoCheck) {

            return (
                <div>
                    <HeaderSub
                        HeaderTitle="내정보"
                        ComponentUrl="MyPage"
                        RenderComponent={(RenderName) => this.setState({ RenderName: RenderName })}
                        ComponentName={this.state.RenderName}
                    />
                    <MyInfoCheck
                        RenderComponent={(RenderName, ContentState) => this.setState({ RenderName: RenderName, ContentState: ContentState })}
                    />
                </div>
            );
        }
        else if (this.state.RenderName === this.CompName.StoreInfo) {
            return (
                <div>
                    <HeaderSub
                        HeaderTitle="매장정보"
                        ComponentUrl="MyPage"
                        RenderComponent={(RenderName) => this.setState({ RenderName: RenderName })}
                        ComponentName={this.state.RenderName}
                    />
                    <StoreInfo
                        RenderComponent={(RenderName, ContentState) => this.setState({ RenderName: RenderName, ContentState: ContentState })}
                        ContentState={this.state.ContentState}
                    />
                </div>
            );
        }
        else if (this.state.RenderName === this.CompName.PhotoUpload) {
            return (
                <div>
                    <HeaderSub
                        HeaderTitle="매장사진"
                        ComponentUrl="StoreInfo"
                        RenderComponent={(RenderName, ContentState) => this.setState({ RenderName: RenderName, ContentState: ContentState })}
                        ContentState={this.state.ContentState}
                        ComponentName={this.state.RenderName}
                    />
                    <SimpleFileUpLoad
                        RenderComponent={(RenderName, ContentState) => this.setState({ RenderName: RenderName, ContentState: ContentState })}
                        ContentState={this.state.ContentState}
                        ComponentName="StoreInfo"
                    />
                </div>
            );
        }
        else if (this.state.RenderName === this.CompName.BusinessInfo) {
            return (
                <div>
                    <HeaderSub
                        HeaderTitle="사업자등록증등록"
                        ComponentUrl="StoreInfo"
                        RenderComponent={(RenderName, ContentState) => this.setState({ RenderName: RenderName, ContentState: ContentState })}
                        ContentState={this.state.ContentState}
                        ComponentName={this.state.RenderName}
                    />
                    <BusinessInfo
                        RenderComponent={(RenderName, ContentState) => this.setState({ RenderName: RenderName, ContentState: ContentState })}
                        ContentState={this.state.ContentState}
                        ComponentName="StoreInfo"
                    />
                </div>
            );
        }
        else if (this.state.RenderName === this.CompName.StoreMsg) {
            return (
                <div>
                    <HeaderSub
                        HeaderTitle="매장 공지사항"
                        ComponentUrl="MyPage"
                        IConClassName="write"
                        IConClick={(e) => { this.setState({ RenderName: "StoreMsgReg" }) }}
                        RenderComponent={(RenderName) => this.setState({ RenderName: RenderName })}
                        ComponentName={this.state.RenderName}
                    />
                    <StoreMsg
                        RenderComponent={(RenderName) => this.setState({ RenderName: RenderName })}
                    />
                </div>
            );
        }
        else if (this.state.RenderName === this.CompName.StoreMsgDtl) {
            return (
                <div>
                    <HeaderSub
                        HeaderTitle="공지사항"
                        ComponentUrl="StoreMsg"
                        RenderComponent={(RenderName) => this.setState({ RenderName: RenderName })}
                        ComponentName={this.state.RenderName}
                    />
                    <StoreMsgDtl
                        RenderComponent={(RenderName) => this.setState({ RenderName: RenderName })}
                    />
                </div>
            );
        }
        else if (this.state.RenderName === this.CompName.StoreMsgReg) {
            return (
                <div>
                    <HeaderSub
                        HeaderTitle="공지사항 글쓰기"
                        ComponentUrl="StoreMsg"
                        RenderComponent={(RenderName) => this.setState({ RenderName: RenderName })}
                        ComponentName={this.state.RenderName}
                    />
                    <StoreMsgReg
                        RenderComponent={(RenderName) => this.setState({ RenderName: RenderName })}
                    />
                </div>
            );
        }
        else if (this.state.RenderName === this.CompName.EmpList) {
            return (
                <div>
                    <HeaderSub
                        HeaderTitle="직원계정관리"
                        ComponentUrl="MyPage"
                        RenderComponent={(RenderName) => this.setState({ RenderName: RenderName })}
                        ComponentName={this.state.RenderName}
                    />
                    <EmpList
                        RenderComponent={(RenderName) => this.setState({ RenderName: RenderName })}
                    />
                </div>
            );
        }
        else if (this.state.RenderName === this.CompName.AccountNumber) {
            return (
                <div>
                    <HeaderSub
                        HeaderTitle="계좌정보 관리"
                        ComponentUrl="MyPage"
                        RenderComponent={(RenderName) => this.setState({ RenderName: RenderName })}
                        ComponentName={this.state.RenderName}
                    />
                    <AccountNumber
                        RenderComponent={(RenderName) => this.setState({ RenderName: RenderName })}
                    />
                </div>
            );
        }
        else if (this.state.RenderName === this.CompName.CostSettleList) {
            return (
                <div>
                    <HeaderSub
                        HeaderTitle="정산하기"
                        ComponentUrl="MyPage"
                        RenderComponent={(RenderName) => this.setState({ RenderName: RenderName })}
                        ComponentName={this.state.RenderName}
                    />
                    <CostSettleList
                        RenderComponent={(RenderName) => this.setState({ RenderName: RenderName })}
                    />
                </div>
            );
        }
        else if (this.state.RenderName === this.CompName.ServiceCenter) {
            return (
                <div>
                    <HeaderSub
                        HeaderTitle="고객센터"
                        ComponentUrl="MyPage"
                        RenderComponent={(RenderName) => this.setState({ RenderName: RenderName })}
                        ComponentName={this.state.RenderName}
                    />
                    <ServiceCenter
                        RenderComponent={(RenderName) => this.setState({ RenderName: RenderName })}
                    />
                </div>
            );
        }
        else if (this.state.RenderName === this.CompName.Withdrawal) {
            return (
                <div>
                    <HeaderSub
                        HeaderTitle="회원탈퇴"
                        ComponentUrl="ServiceCenter"
                        RenderComponent={(RenderName) => this.setState({ RenderName: RenderName })}
                        ComponentName={this.state.RenderName}
                    />
                    <Withdrawal
                        RenderComponent={(RenderName) => this.setState({ RenderName: RenderName })}
                    />
                </div>
            );
        }
        else if (this.state.RenderName === this.CompName.Privacypolicy) {
            return (
                <div>
                    <HeaderSub
                        HeaderTitle="서비스이용약관"
                        ComponentUrl="MyPage"
                        RenderComponent={(RenderName, ContentState) => this.setState({ RenderName: RenderName, ContentState: ContentState })}
                        ContentState={this.state.ContentState}
                        ComponentName={this.state.RenderName}
                    />
                    <Privacypolicy
                        RenderComponent={(RenderName, ContentState) => this.setState({ RenderName: RenderName, ContentState: ContentState })}
                        ContentState={this.state.ContentState}
                    />
                </div>
            );
        }
        else if (this.state.RenderName === this.CompName.Termsofservice) {
            return (
                <div>
                    <HeaderSub
                        HeaderTitle="개인정보 취급방법"
                        ComponentUrl="MyPage"
                        RenderComponent={(RenderName, ContentState) => this.setState({ RenderName: RenderName, ContentState: ContentState })}
                        ContentState={this.state.ContentState}
                        ComponentName={this.state.RenderName}
                    />
                    <Termsofservice
                        RenderComponent={(RenderName, ContentState) => this.setState({ RenderName: RenderName, ContentState: ContentState })}
                        ContentState={this.state.ContentState}
                    />
                </div>
            );
        }
        else if (this.state.RenderName === this.CompName.OrderDtlExcel) {
            return (
                <div>
                    <HeaderSub2
                        HeaderTitle="엑셀주문 현황"
                        ComponentUrl="MyPage"
                        RenderComponent={(RenderName) => this.setState({ RenderName: RenderName })}
                        ComponentName={this.state.RenderName}
                        
                    />
                    <OrderDtlExcel
                        RenderComponent={(RenderName, ContentState) => this.setState({ RenderName: RenderName, ContentState: ContentState })}
                        ContentState={this.state.ContentState}
                    />
                </div>
            );
        }
    }
    render() {
        let RnderAct = this.renderPick();
        return (
            <div>
                {RnderAct}
            </div>
        );
    }
}
